import { Component } from '@angular/core';

@Component({
    selector: 'app-primeng',
    imports: [],
    templateUrl: './primeng.component.html',
    styleUrl: './primeng.component.scss'
})
export class PrimengComponent {

}
